import { PulseTextArea } from 'src/components/PulseUI';

interface DataIssueCommentsProps {
  comments: string;
  setComments?: (value: string) => void;
}

const DataIssueComments = ({
  comments,
  setComments,
}: DataIssueCommentsProps) => {
  return (
    <div className="mt-2" data-testid="data-issue-comments">
      <label
        htmlFor="data-issue-comments-textarea"
        className="text-sm font-medium"
      >
        Comments:
      </label>
      <PulseTextArea
        id="data-issue-comments-textarea"
        disabled={!setComments}
        placeholder="Provide any additional information here"
        value={comments}
        onChange={(e) => setComments?.(e.target.value)}
        className="min-h-[100px] max-h-[100px]"
        resize="none"
        aria-label="Comments"
        data-testid="data-issue-comments-textarea"
      />
    </div>
  );
};

export { DataIssueComments };
